export interface NormalizedToolAction {
  name: string
  description: string
  enabled: boolean
  access_configured?: boolean
}

type ActionRecord = Partial<NormalizedToolAction> & Record<string, unknown>

function normalizeAction(name: string, value: unknown): NormalizedToolAction | null {
  if (!value || typeof value !== "object") return null
  const record = value as ActionRecord
  const actionName = typeof record.name === "string" && record.name ? record.name : name
  const normalized: NormalizedToolAction = {
    name: actionName,
    description: typeof record.description === "string" ? record.description : "",
    enabled: record.enabled === true,
  }
  if (record.access_configured === true) {
    normalized.access_configured = true
  }
  return normalized
}

export function normalizeToolActions(value: unknown): NormalizedToolAction[] {
  if (Array.isArray(value)) {
    return value
      .map((item) => normalizeAction(typeof item?.name === "string" ? item.name : "", item))
      .filter((item): item is NormalizedToolAction => item !== null && item.name.length > 0)
  }

  if (!value || typeof value !== "object") {
    return []
  }

  return Object.entries(value)
    .map(([name, item]) => normalizeAction(name, item))
    .filter((item): item is NormalizedToolAction => item !== null && item.name.length > 0)
}
